module.exports = "/work-site/img/logo.f2a769c8.png";